<template>
  <CDataTable
    :items="rows"
    :fields="fields"
    :items-per-page="20"
    pagination
    hover
    striped
    small
    bordered
  >
    <template #started_at="{ item }">
      <td>{{ formatDate(item.started_at) }}</td>
    </template>

    <template #import_type="{ item }">
      <td>{{ importTypeLabel(item.import_type) }}</td>
    </template>

    <template #status="{ item }">
      <td><ImportHistoryStatusBadge :status="item.status" /></td>
    </template>

    <template #result="{ item }">
      <td>
        {{ Number(item.created_count || 0) }} creados, {{ Number(item.updated_count || 0) }} actualizados,
        {{ Number(item.skipped_count || 0) }} ignorados, {{ Number(item.error_count || 0) }} errores
      </td>
    </template>

    <template #actions="{ item }">
      <td class="history-actions-cell">
        <CButton size="sm" color="info" class="mr-1" title="Ver detalle" @click="$emit('view-detail', item)">
          <CIcon name="cil-list" />
        </CButton>
        <CButton
          size="sm"
          color="primary"
          class="mr-1"
          title="Descargar archivo"
          :disabled="!canDownloadSource(item)"
          @click="$emit('download-source', item)"
        >
          <CIcon name="cil-cloud-download" />
        </CButton>
        <CButton
          size="sm"
          color="dark"
          title="Revertir"
          :disabled="!canUndo(item)"
          @click="$emit('undo-import', item)"
        >
          <CIcon name="cil-sync" />
        </CButton>
      </td>
    </template>
  </CDataTable>
</template>

<script>
import ImportHistoryStatusBadge from './ImportHistoryStatusBadge.vue'

export default {
  name: 'ImportHistoryTable',
  components: { ImportHistoryStatusBadge },
  props: {
    rows: { type: Array, default: () => [] }
  },
  data() {
    return {
      fields: [
        { key: 'started_at', label: 'Fecha' },
        { key: 'import_type', label: 'Tipo' },
        { key: 'status', label: 'Estado' },
        { key: 'result', label: 'Resultado' },
        { key: 'actions', label: 'Acciones' }
      ]
    }
  },
  methods: {
    canDownloadSource(item) {
      return !!(item && item.source_file_path)
    },
    canUndo(item) {
      const status = (item && item.status ? item.status : '').toString()
      return status === 'completed' || status === 'completed_with_observations'
    },
    importTypeLabel(type) {
      if (type === 'initial_load') {
        return 'Carga inicial'
      }

      return 'Agregar o actualizar invitados'
    },
    formatDate(value) {
      if (!value) return 'Sin fecha'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
    }
  }
}
</script>

<style scoped>
.history-actions-cell {
  white-space: nowrap;
}
</style>
